var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonTrees128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.672 93.4821C41.58 93.4839 36.6325 93.4998 36.0493 93.4819C27.2976 93.2137 21 82.7101 21 70.2449C21 51.3237 30.2909 35.5291 39.0627 31.8245C40.2374 31.2862 41.4511 31.0029 42.6748 31.0029L42.75 31.0042L42.8252 31.0029C44.0488 31.0029 45.2626 31.2862 46.4374 31.8252C55.2091 35.5291 64.4999 51.3237 64.4999 70.2449C64.4999 82.7101 58.2023 93.2137 49.4507 93.4819C48.8675 93.4998 43.92 93.4839 42.8279 93.4821H42.672Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.75 66.9805V112.426",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9894 85.916L34.479 76.4482",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6947 93.6073C80.3786 93.6096 74.4163 93.6291 73.7135 93.607C63.1666 93.2761 55.5771 80.3138 55.5771 64.9307C55.5771 41.5804 66.7738 22.0886 77.345 17.5168C78.7606 16.8525 80.2233 16.5029 81.698 16.5029L81.7886 16.5045L81.8793 16.5029C83.3539 16.5029 84.8166 16.8525 86.2325 17.5177C96.8035 22.0886 108 41.5804 108 64.9307C108 80.3138 100.411 93.2761 89.8638 93.607C89.161 93.6291 83.1987 93.6096 81.8826 93.6073H81.6947Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7246 54.1201V112.426",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9613 72.9286L74.5366 63.5244",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7243 80.4516L91.1494 71.0474",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonTrees128);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonTrees128.60b573955b7ac10977b61fe2eea40a29.svg";
export { ForwardRef as ReactComponent };